import axios from 'axios';
import * as qs from 'qs';
import { ICrudGetAction } from 'react-jhipster';
import { FAILURE, REQUEST, SUCCESS } from 'app/shared/reducers/action-type.util';
import { defaultValue, ITableType } from 'app/shared/model/commission-reportment.model';
import { ICrudGetListAction } from 'app/shared/model/list';
import { cleanEntity } from 'app/shared/util/entity-utils';
import { flattenKey } from 'app/shared/util/object-utils';
// 请求
export const ACTION_TYPES = {
  FETCH_LIST: 'transaction/FETCH_LIST', // 列表
  FETCH_DETAIL: 'transaction/FETCH_DETAIL', // 详情
  FETCH_TRANSACTION_TOTAL: 'transaction/FETCH_TRANSACTION_TOTAL', // 统计
  BATCH_CONFIRMS_TRANSACTION: 'transaction/BATCH_CONFIRMS_TRANSACTION', // 批量确认
  BATCH_ROLLBACK_TRANSACTION: 'transaction/BATCH_ROLLBACK_TRANSACTION', // 批量撤销
  RESET: 'transaction/RESET' // 重置
};
// state
const initialState = {
  loading: false,
  fetching: false,
  loadMore: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<ITableType>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
  totalFetching: false, // 统计loading
  commissionAmount: null // 用电金额
};

export type cTransactionState = Readonly<typeof initialState>;

// Reducer
export default (state: cTransactionState = initialState, action): cTransactionState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_DETAIL):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case REQUEST(ACTION_TYPES.FETCH_LIST):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
        fetching: true,
        totalFetching: true
      };
    case FAILURE(ACTION_TYPES.FETCH_DETAIL):
    case FAILURE(ACTION_TYPES.FETCH_LIST):
      return {
        ...state,
        loading: false,
        fetching: false,
        loadMore: false,
        updating: false,
        updateSuccess: false,
        totalFetching: true,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_DETAIL):
      const { data } = action.payload;
      let { industry, source, satisfaction } = data;

      const otherChange = (value, name) => {
        const arr = value.split(':');
        data[`${name}_other`] = arr[1];
        return arr[0];
      };

      industry = industry && industry.indexOf('其他') > -1 ? otherChange(industry, 'reason') : industry;
      source = source && source.indexOf('其他') > -1 ? otherChange(source, 'source') : source;

      if (satisfaction && satisfaction.indexOf('其他') > -1) {
        const arr = satisfaction.split(',');
        const num = arr.findIndex(item => item.indexOf('其他') > -1);
        arr[num] = otherChange(arr[num], 'satisfaction');
        satisfaction = arr;
      }

      return {
        ...state,
        loading: false,
        entity: { ...data, satisfaction, industry, source }
      };
    case SUCCESS(ACTION_TYPES.FETCH_LIST):
      return {
        ...state,
        loading: false,
        fetching: false,
        totalFetching: false,
        entities: action.payload.data.content || [],
        totalItems: parseInt(action.payload.data['totalElements'], 10)
      };
    case SUCCESS(ACTION_TYPES.FETCH_TRANSACTION_TOTAL):
      return {
        ...state,
        totalFetching: false,
        commissionAmount: action.payload.data
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = '/fy/deal';
// 列表
export const getEntities: ICrudGetListAction<ITableType> = (page, size, sort = '', searchForm) => {
  const requestUrl = `${apiUrl}/list?page=${page}&size=${size}`;
  return {
    type: ACTION_TYPES.FETCH_LIST,
    payload: axios.get<ITableType>(`${requestUrl}`, {
      params: flattenKey(searchForm),
      paramsSerializer: params => qs.stringify(params)
    }),
    meta: { transformUserName: true }
  };
};
// 详情
export const getEntity: ICrudGetAction<ITableType> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_DETAIL,
    payload: axios.get<ITableType>(requestUrl)
  };
};
export const reset = () => ({
  type: ACTION_TYPES.RESET
});

// 统计
export const getTotal = searchForm => ({
  type: ACTION_TYPES.FETCH_TRANSACTION_TOTAL,
  payload: axios.get(`${apiUrl}/total`, {
    params: flattenKey({ ...searchForm }),
    paramsSerializer: params => qs.stringify(params)
  })
});

// 更新
export function updateInfo(entity) {
  return new Promise((resolve, reject) => {
    axios
      .put(`${apiUrl}/update`, cleanEntity(entity))
      .then(response => {
        resolve(response.data);
      })
      .catch(() => {
        reject();
      });
  });
}

// 批量确认
export const batchConfirm = (ids: any[]) => async dispatch => {
  const requestUrl = `${apiUrl}/confirms`;
  const result = await dispatch({
    type: ACTION_TYPES.BATCH_CONFIRMS_TRANSACTION,
    payload: axios.put<ITableType>(requestUrl, { ids }, { paramsSerializer: params => qs.stringify(params) })
  });
  // dispatch(getEntities());
  return result;
};

// 批量撤销
export const batchRollback = (ids: any[]) => async dispatch => {
  const requestUrl = `${apiUrl}/rollbacks`;
  const result = await dispatch({
    type: ACTION_TYPES.BATCH_ROLLBACK_TRANSACTION,
    payload: axios.put<ITableType>(requestUrl, { ids }, { paramsSerializer: params => qs.stringify(params) })
  });
  // dispatch(getEntities());
  return result;
};
